var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showToolbar)?_c('div',{staticClass:"dij-diagrambuilder-toolbar"},_vm._l((_vm.tools),function(tool,index){return _c('div',{key:index,staticClass:"tool-entry tool-font-size",class:{
      [tool.class]: true,
      disabled: !_vm.isImageSelected,
      'dij-tool-active': _vm.mode === tool.mode,
      separator: tool.hasSeparatorBelow,
    },attrs:{"title":_vm.$t(tool.title)},on:{"click":function($event){return _vm.toolClick(tool)}}},[(tool.icon)?_c('b-icon',{attrs:{"icon":tool.icon,"type":_vm.mode === tool.mode ? 'is-info' : ''}}):_vm._e()],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }